import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PlusCircleIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M10.0003 1.66699C5.39783 1.66699 1.66699 5.39783 1.66699 10.0003C1.66699 14.6028 5.39783 18.3337 10.0003 18.3337C14.6028 18.3337 18.3337 14.6028 18.3337 10.0003C18.3337 5.39783 14.6028 1.66699 10.0003 1.66699ZM13.3337 10.8337H10.8337V13.3337C10.8337 13.7937 10.4603 14.167 10.0003 14.167C9.54033 14.167 9.16699 13.7937 9.16699 13.3337V10.8337H6.66699C6.20699 10.8337 5.83366 10.4603 5.83366 10.0003C5.83366 9.54033 6.20699 9.16699 6.66699 9.16699H9.16699V6.66699C9.16699 6.20699 9.54033 5.83366 10.0003 5.83366C10.4603 5.83366 10.8337 6.20699 10.8337 6.66699V9.16699H13.3337C13.7937 9.16699 14.167 9.54033 14.167 10.0003C14.167 10.4603 13.7937 10.8337 13.3337 10.8337Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PlusCircleIcon.propTypes = {
  sx: PropTypes.object,
};

export default PlusCircleIcon;
